import { DragOverlay } from '@dnd-kit/core'
import { OverlayBonnet } from './OverlayBonnet'
import { VehicleAllocation } from '@/types/vehicleAllocation'
import { useVehicleAllocationStore } from '@/pages/VehicleAllocationController'

interface DragOverlayAllocationProps {
    allocation: VehicleAllocation
    route: string
}

export const DragOverlayAllocation = ({ allocation, route }: DragOverlayAllocationProps) => {
    const { activeId, allocationChanges } = useVehicleAllocationStore()

    return (
        <DragOverlay
            dropAnimation={{
                duration: 100,
                easing: 'cubic-bezier(0.18, 0.67, 0.6, 1.22)',
            }}
        >
            {activeId ? (
                <OverlayBonnet
                    allocation={allocation.allocations.find((allocation) => allocation.run === activeId)!}
                    allocationChange={allocationChanges.find((allocationChange) => allocationChange.run === activeId)}
                    route={route}
                />
            ) : null}
        </DragOverlay>
    )
}
